'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { useRouter } from 'next/navigation'
import { Dialog, DialogPanel, DialogBackdrop } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/20/solid'

import { myCruzApi } from '@/api'
import { useGlobalStore } from '@/store/provider'
import { Button, Divider, H1, SignInWithEmail, SignInWithApple, SignInWithGoogle, SignInWithFacebook } from '@/components'
import { pages } from '@/settings'

export function ModalSignIn() {
  const { user, setUser, modalSignIn, setModalSignIn } = useGlobalStore((state) => state)
  const router = useRouter()

  async function afterSignIn() {
    const { saveVehicleId, like, saveSearch } = modalSignIn || {}
    setModalSignIn({ show: false })
    if (saveSearch) {
      setModalSignIn({ show: false, saveSearch })
      return
    }
    if (saveVehicleId) {
      const { data } = await myCruzApi.saveVehicle.toggleSave(saveVehicleId)
      setUser(_.assign(user, data), null)
    }
    if (like) {
      const { name, id } = like
      await myCruzApi.toggleLike({ name, id })
    }
  }

  function gotoJoinCruz() {
    setModalSignIn({ show: false })
    router.push(pages.joinCruz.href)
  }

  function gotoForgotPassword() {
    setModalSignIn({ show: false })
    router.push(pages.forgotPassword.href)
  }

  function handleClose() {
    setModalSignIn({ show: false })
  }

  return (
    <Dialog autoFocus={false} open={modalSignIn?.show || false} onClose={handleClose} className='relative z-40'>
      <DialogBackdrop transition className='dialog-backdrop' />
      <div className='fixed inset-0 z-10 w-full overflow-y-auto'>
        <div className='flex min-h-full items-center justify-center p-6'>
          <DialogPanel className={twMerge('w-sm rounded-lg p-6 relative bg-white dark:bg-zinc-900 shadow-inner md:shadow-lg')}>
            <div className='flex items-start justify-between mb-2'>
              <H1>Sign in</H1>
              <Button type='button' variant='transparent' className='rounded-full' onClick={handleClose}>
                <XMarkIcon className='size-6 text-zinc-500 dark:text-zinc-400' />
              </Button>
            </div>
            <SignInWithEmail afterSignIn={afterSignIn} />
            <div className='text-center mb-2'>
              <button type='button' onClick={gotoForgotPassword} className='md:text-sm font-medium hover:text-red-800 dark:hover:text-white' >
                {pages.forgotPassword.name}
              </button>
            </div>
            <Divider label='or' className='mb-4' />
            <div className='space-y-4'>
              <Button type='button' variant='outline' className='btn-signin' onClick={gotoJoinCruz}>
                <span>Join Cruz<sup className='text-[7px]'>TM</sup> with Email</span>
              </Button>
              <SignInWithGoogle afterSignIn={afterSignIn} />
              <SignInWithApple afterSignIn={afterSignIn} />
              <SignInWithFacebook afterSignIn={afterSignIn} />
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}
